"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _loveButton = _interopRequireDefault(require("./loveButton.js"));

var _fullscreenSocialDownload = _interopRequireDefault(require("./fullscreenSocialDownload.js"));

var _fullscreenShareButtons = _interopRequireDefault(require("./fullscreenShareButtons.js"));

var _utils = require("../utils");

var _translationUtils = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/translationUtils"));

var _FullscreenExpandCloseButton = _interopRequireDefault(require("./FullscreenExpandCloseButton"));

var _lodash = _interopRequireDefault(require("lodash"));

var _info = _interopRequireDefault(require("-!svg-react-loader!../assets/images/fullscreen-store/info.svg"));

var _info_invert = _interopRequireDefault(require("-!svg-react-loader!../assets/images/fullscreen-store/info_invert.svg"));

var _fullscreenEvents = _interopRequireDefault(require("../constants/fullscreenEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenDesktopNavbar =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenDesktopNavbar, _React$Component);

  function FullscreenDesktopNavbar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleShareArrowNavigation = _this.handleShareArrowNavigation.bind(_assertThisInitialized(_this));
    _this.state = {
      shareBoxIsOpened: false,
      focusedShareIcon: 0
    };
    return _this;
  }

  var _proto = FullscreenDesktopNavbar.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.currentWindow.expanded !== this.props.currentWindow.expanded) {
      if (!this.props.currentWindow.expanded) {
        this.fullscreenExpandButton.focus();
      }
    }
  };

  _proto.hasAdditionalNavbarElement = function hasAdditionalNavbarElement() {
    var additionalNavbarElement = this.props.additionalNavbarElement;
    return typeof additionalNavbarElement === 'function';
  };

  _proto.handleShareArrowNavigation = function handleShareArrowNavigation(e, type) {
    if (!this.state.shareBoxIsOpened) {
      //the keypress events are only effective when the share box was opened via Click or Focus+Enter
      return true;
    }

    switch (e.keyCode || e.charCode) {
      case 38: //up

      case 37: //left

      case 33:
        //page up
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          focusedShareIcon: Math.max(1, this.state.focusedShareIcon - 1)
        });
        return false;

      case 39: //right

      case 40: //down

      case 34:
        //page down
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          focusedShareIcon: Math.min(type === 'text' ? 4 : 5, this.state.focusedShareIcon + 1)
        });
        return false;

      case 9: //tab

      case 27:
        //esc
        e.preventDefault();
        e.stopPropagation();
        this.shareBoxButton.focus();
        this.setState({
          focusedShareIcon: 0,
          shareBoxIsOpened: false
        });
        return false;
    }

    return true;
  };

  _proto.getLoveButton = function getLoveButton() {
    var props = _lodash["default"].pick(this.props.current.item, ['id', 'item', 'idx', 'itemId', 'hashtag', 'type']);

    var loveButton = _react["default"].createElement(_loveButton["default"], _extends({}, props, {
      key: "fullscreen-love-" + this.props.id,
      layout: "fullscreen",
      device: "desktop",
      styleParams: this.props.styleParams,
      isPreview: this.props.isPreview // to preserve LoveButton API
      ,
      showCounter: true,
      actions: this.props.actions
    }, this.props.current.itemLoveData));

    return this.props.isPreview ? _react["default"].createElement("div", {
      title: _translationUtils["default"].getByKey('This option is not available in editor')
    }, loveButton) : _react["default"].createElement(_react["default"].Fragment, null, loveButton);
  };

  _proto.getDownload = function getDownload() {
    return _react["default"].createElement(_fullscreenSocialDownload["default"], {
      key: "fullscreen-download-" + this.props.id,
      layout: "fullscreen",
      device: "desktop",
      hasAdditionalNavbarElement: this.hasAdditionalNavbarElement(),
      current: this.props.current,
      styleParams: this.props.styleParams,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    });
  };

  _proto.getShareComponent = function getShareComponent(showDownload, shareIcon) {
    var _this2 = this;

    var storeClass = this.hasAdditionalNavbarElement() ? 'pro-fullscreen-store' : '';
    var shareBoxOpenedClass = this.state.shareBoxIsOpened ? 'pro-fullscreen-hovered' : '';
    var type = this.props.current.item.type;
    return _react["default"].createElement("div", {
      key: "shareComponent",
      className: "fullscreen-icon fullscreen-social-share-box " + storeClass + " " + shareBoxOpenedClass,
      onKeyDown: function onKeyDown(e) {
        return _this2.handleShareArrowNavigation(e, type);
      }
    }, shareIcon, _react["default"].createElement(_fullscreenShareButtons["default"], {
      item: this.props.current.item,
      focus: this.state.focusedShareIcon,
      ariaHidden: !this.state.shareBoxIsOpened,
      actions: {
        eventsListener: this.props.actions.eventsListener
      }
    }));
  };

  _proto.getFakeShareComponent = function getFakeShareComponent(showDownload, shareIcon) {
    var storeClass = this.hasAdditionalNavbarElement() ? 'pro-fullscreen-store' : '';
    return _react["default"].createElement("div", {
      className: "show-tooltip fullscreen-icon fullscreen-social-share-box " + storeClass,
      title: _translationUtils["default"].getByKey('Gallery_Sharing_Disabled_In_Editor')
    }, shareIcon);
  };

  _proto.getShareIcon = function getShareIcon() {
    var _this3 = this;

    return _react["default"].createElement("button", {
      className: 'fullscreen-social-share-icon progallery-svg-font-icons-share-store has-custom-focus',
      tabIndex: 0,
      title: 'Share',
      ref: function ref(button) {
        return _this3.shareBoxButton = button;
      },
      onClick: function onClick() {
        _this3.setState({
          shareBoxIsOpened: !_this3.state.shareBoxIsOpened
        });
      },
      "aria-haspopup": "menu",
      "aria-pressed": this.state.shareBoxIsOpened
    });
  };

  _proto.getShareButtons = function getShareButtons() {
    var showDownload = this.props.styleParams.allowDownload && !this.props.current.item.isDemo;
    var shareIcon = this.getShareIcon();

    if (!this.props.styleParams.allowSocial) {
      return false;
    }

    return !this.props.isPreview ? this.getShareComponent(showDownload, shareIcon) : this.getFakeShareComponent(showDownload, shareIcon);
  };

  _proto.getAdditionalNavbarElement = function getAdditionalNavbarElement() {
    var additionalNavbarElement = this.props.additionalNavbarElement;

    try {
      if (additionalNavbarElement) {
        return additionalNavbarElement(this.props);
      } else {
        return false;
      }
    } catch (e) {
      console.error('Could not get additional sidebar element', e);
    }
  };

  _proto.getSocialBarContainer = function getSocialBarContainer() {
    var styleParams = this.props.styleParams;
    var loveButton = styleParams.loveButton ? this.getLoveButton() : '';
    var downloadButton = this.getDownload();
    var shareButtons = this.getShareButtons();
    return _react["default"].createElement("div", {
      className: 'fullscreen-social'
    }, [!_utils.utils.isMobile() ? this.getExpandButtonIfNeeded() : false, this.getAdditionalNavbarElement(), this.getMoreInfoButton(), downloadButton, loveButton, shareButtons]);
  };

  _proto.getCloseShrinkButtonIfNeeded = function getCloseShrinkButtonIfNeeded() {
    var _this4 = this;

    if (!this.props.currentWindow.expanded) {
      return false;
    }

    return _react["default"].createElement(_FullscreenExpandCloseButton["default"], {
      iconClass: 'progallery-svg-font-icons-shrink-arrow pro-fullscreen-shrink-button has-custom-focus',
      onClick: function onClick() {
        return _this4.props.actions.closeExpandBrowser();
      },
      tabIndex: 0,
      title: 'Exit fullscreen',
      shoudAutofocus: !!this.props.navigatedInto
    });
  };

  _proto.getCloseButton = function getCloseButton() {
    var _this5 = this;

    var button = _react["default"].createElement(_FullscreenExpandCloseButton["default"], {
      iconClass: 'progallery-svg-font-icons-close-x pro-fullscreen-x-button has-custom-focus',
      onClick: function onClick() {
        if (_this5.props.currentWindow.expanded) {
          _this5.props.actions.closeExpandBrowser(true);
        } else {
          var eventData = {
            itemIdx: _this5.props.current.idx
          };

          _this5.props.actions.eventsListener(_fullscreenEvents["default"].CLOSE_FULLSCREEN, eventData);
        }
      },
      tabIndex: 0,
      title: "Exit " + (this.props.currentWindow.expanded ? 'fullscreen' : 'expand mode'),
      shoudAutofocus: !!this.props.navigatedInto,
      shouldRefocusOnCloseXButton: this.props.shouldRefocusOnCloseXButton
    });

    return _react["default"].createElement("div", {
      className: "fullscreen-nav"
    }, button);
  };

  _proto.getNavigationArrows = function getNavigationArrows() {
    var _this6 = this;

    return [_react["default"].createElement("button", {
      className: 'fullscreen-icon fullscreen-next progallery-svg-font-icons-arrow_right ' + (this.props.current.idx >= this.props.totalItems - 1 ? ' fullscreen-icon-disabled ' : ''),
      ref: function ref(_ref) {
        return _this6.rightButtonElement = _ref;
      },
      onClick: function onClick() {
        return _this6.props.actions.fadeToNextSlide(1);
      },
      tabIndex: this.props.current.idx >= this.props.totalItems - 1 ? -1 : _utils.utils.getTabIndex('fullscreenNext'),
      title: 'Next item'
    }), _react["default"].createElement("button", {
      className: 'fullscreen-icon fullscreen-prev progallery-svg-font-icons-arrow_left ' + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
      onClick: function onClick() {
        return _this6.props.actions.fadeToNextSlide(-1);
      },
      tabIndex: this.props.current.idx <= 0 ? -1 : _utils.utils.getTabIndex('fullscreenPrev'),
      title: 'Previous item'
    })];
  };

  _proto.getMoreInfoButton = function getMoreInfoButton() {
    var _this$props = this.props,
        styleParams = _this$props.styleParams,
        current = _this$props.current,
        actions = _this$props.actions,
        showInfo = _this$props.showInfo;
    var shouldHideMoreInfoButton = !styleParams.showInfoExpandButton || this.props.currentWindow.expanded || _utils.utils.isMobile() || !current.hasInfo;

    if (shouldHideMoreInfoButton) {
      return false;
    }

    var svgInfoWhite = _react["default"].createElement("div", null, (0, _info["default"])());

    var svgInfoBlack = _react["default"].createElement("div", null, (0, _info_invert["default"])());

    return _react["default"].createElement("button", {
      className: 'fullscreen-icon fullscreen-info',
      onClick: function onClick() {
        return actions.toggleInfo();
      },
      tabIndex: _utils.utils.getTabIndex('fullscreenInfo'),
      "aria-label": showInfo ? 'Hide Details' : 'Show More Details'
    }, showInfo ? svgInfoBlack : svgInfoWhite);
  };

  _proto.getExpandButtonIfNeeded = function getExpandButtonIfNeeded() {
    var _this7 = this;

    var _this$props2 = this.props,
        styleParams = _this$props2.styleParams,
        actions = _this$props2.actions;

    if (!styleParams.allowFullscreenExpand) {
      return false;
    }

    var expandIconClass = 'progallery-svg-font-icons-expand-arrow';
    return _react["default"].createElement("button", {
      key: "fullscreen-expand-" + this.props.id,
      className: "fullscreen-icon has-custom-focus fullscreen-expand " + expandIconClass,
      onClick: function onClick() {
        return actions.expandBrowser();
      },
      tabIndex: 0,
      title: 'Open in fullscreen',
      ref: function ref(_ref2) {
        return _this7.fullscreenExpandButton = _ref2;
      }
    });
  };

  _proto.getNavigationContainer = function getNavigationContainer() {
    return _react["default"].createElement("div", {
      className: "fullscreen-nav"
    }, this.getCloseShrinkButtonIfNeeded());
  };

  _proto.render = function render() {
    if (_utils.utils.isSmallScreen()) {
      return false;
    }

    var shouldHideSocialBar = this.props.currentWindow.expanded;
    var socialBarContainer = shouldHideSocialBar ? false : this.getSocialBarContainer();
    var navigationContainer = this.getNavigationContainer();
    var closeButton = this.getCloseButton();
    return _react["default"].createElement("div", {
      className: "fullscreen-desktop-navbar-container"
    }, socialBarContainer, navigationContainer, closeButton);
  };

  return FullscreenDesktopNavbar;
}(_react["default"].Component);

var _default = FullscreenDesktopNavbar;
exports["default"] = _default;